import {useEffect, useRef, useState} from "react"
import {
    Container,
    Box,
    Card,
    Typography,
    ThemeProvider,
    createTheme,
    Alert,
    TextField,
    Snackbar,
    Button
} from "@mui/material"
import {app, initApp, updateUser} from "./firebase"
import {collection, doc, getDoc, getFirestore} from "firebase/firestore";
import {GiftedTrialCode} from "./firebase/types";

export function App() {
    const [submitted, setSubmitted] = useState<boolean>(false)
    const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false)
    const [submitResult, setSubmitResult] = useState<{ status: null | "success" | "error", message: string, }>({
        status: null,
        message: ""
    })
    const [formState, setFormState] = useState<{ email: string, instagramHandle: string, pinCode: string }>({
        email: "",
        instagramHandle: "",
        pinCode: ""
    })
    const theme = createTheme({palette: {mode: "light"}})
    const db = getFirestore(app)

    // This will represents the promo codes coming from the db
    const codes = useRef<GiftedTrialCode>({})

    useEffect(() => {
        initApp()
        getPromoCodes().catch((e) => console.log("Error at getPromoCodes() ", e))
    }, [])

    const getPromoCodes = async () => {
        let date = new Date(),
            year = date.getFullYear(),
            month = date.getMonth() + 1,
            giftTrialCodeRef = await collection(db, 'giftTrialCode'),
            monthAndYear = `${month}-${year}`,
            docRef = await doc(giftTrialCodeRef, monthAndYear),
            giftedTrialDoc = await getDoc(docRef)
        codes.current = giftedTrialDoc.data()
    }


    const onChange = (value, label) => {
        const newState = {...formState, [label]: value}
        setFormState(newState)
    }
    const handleSnackbarClose = () => {
        setSnackbarOpen(false)
    }

    const onSubmit = async () => {
        if (formState.pinCode.trim().toUpperCase() === codes.current?.value?.trim()?.toUpperCase()) {
            if (formState.email && formState.instagramHandle && formState.pinCode) {
                const result = await updateUser(formState, codes.current)
                setSubmitResult(result)
                setSnackbarOpen(true)
                if (result.status === "success") setSubmitted(true)
            } else {
                setSubmitResult({status: "error", message: "Email or Instagram Handle are not filled out"})
                setSnackbarOpen(true)
            }
        } else {
            if (formState.email && formState.pinCode) {
                const result = await updateUser(formState, codes.current)
                setSubmitResult(result)
                setSnackbarOpen(true)
                if (result.status === "success") setSubmitted(true)
            } else {
                setSubmitResult({status: "error", message: "Email is not filled out"})
                setSnackbarOpen(true)
            }
        }
    }


    const cardSx = {marginTop: 3, padding: 3}

    return (
        <div style={{
            display: 'flex',
            flexDirection: {xs: 'column', md: 'row'},
            alignItems: 'center',

        }}>
            <ThemeProvider theme={theme}>
                <Container>
                    <Box sx={{
                        width: "80%",
                        paddingLeft: '10%',
                        paddingRight: '10%'

                    }}>
                        <Snackbar
                            anchorOrigin={{vertical: "top", horizontal: "center"}}
                            open={snackbarOpen}
                            onClose={handleSnackbarClose}
                            autoHideDuration={6000}
                        >
                            {submitResult.status
                                ? <Alert onClose={handleSnackbarClose} severity={submitResult.status}
                                         sx={{width: '100%'}}>
                                    <Typography>{submitResult.message}</Typography>
                                </Alert>
                                : null}
                        </Snackbar>
                        {submitted
                            ? <Box>
                                <Card sx={cardSx}>
                                    <Typography>
                                        {formState.email.toLowerCase()} has been upgraded to premium! Thank you so much!
                                        Enjoy your {formState.instagramHandle ? "year" : "two months"} of premium
                                        membership 😁
                                    </Typography>
                                </Card>
                            </Box>
                            : <Card sx={cardSx}>
                                <Box>
                                    <br/>
                                    <TextField sx={{width: "100%"}} value={formState.email}
                                               onChange={(e) => onChange(e.target.value, "email")} id="standard-basic"
                                               label="Email" variant="standard"/>
                                    <br/>
                                    <TextField sx={{width: "100%"}} value={formState.pinCode}
                                               onChange={(e) => onChange(e.target.value, "pinCode")} id="standard-basic"
                                               label="Pin Code" variant="standard"/>
                                    <br/>
                                    {formState.pinCode.trim().toUpperCase() === codes.current?.value?.trim()?.toUpperCase() ?
                                        <TextField sx={{width: "100%"}} value={formState.instagramHandle}
                                                   onChange={(e) => onChange(e.target.value, "instagramHandle")}
                                                   id="standard-basic" label="Instagram Handle"
                                                   variant="standard"/> : null}
                                    <br/>

                                    <Button variant='outlined' sx={{color: "#009FBC"}}
                                            onClick={onSubmit}>Upgrade</Button>
                                    <br/>
                                </Box>
                            </Card>}
                    </Box>
                </Container>
            </ThemeProvider>
        </div>

    );
}
